import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { VaStatusBannerComponent } from './va-status-banner.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [VaStatusBannerComponent],
  imports: [CommonModule, MatIconModule],
  exports: [VaStatusBannerComponent],
})
export class VaStatusBannerModule {}
